var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "contests-terms-and-conditions-page" }, [
    _vm.contestName
      ? _c("h1", { staticClass: "contest-name" }, [
          _vm._v(_vm._s(_vm.contestName))
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "contest-content-wrap" }, [
      _c("div", [
        _vm.contestRules
          ? _c("div", { domProps: { innerHTML: _vm._s(_vm.contestRules) } })
          : _c("div", [
              _c("h2", { staticClass: "contest-missing-rules-url" }, [
                _vm._v(_vm._s(_vm.$t("Contests.TnC.Missing")))
              ])
            ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("div", { staticClass: "contest-terms-actions" }, [
          _c(
            "div",
            { staticClass: "d-flex justify-center align-center mt-3" },
            [
              _c("v-switch", {
                staticClass: "input--accept-terms",
                attrs: {
                  "hide-details": "",
                  disabled: !_vm.contestRules,
                  color: "success",
                  label: _vm.$t("Contests.TnC.Label")
                },
                model: {
                  value: _vm.acceptTermsModel,
                  callback: function($$v) {
                    _vm.acceptTermsModel = $$v
                  },
                  expression: "acceptTermsModel"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-flex align-center mt-3 contest-buttons" },
            [
              _c(
                "v-btn",
                {
                  staticClass: "btn--cancel secondary-btn",
                  attrs: { to: { name: "contests" }, "active-class": "" }
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("Contests.Alias.Page.Cancel")) +
                      "\n          "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "btn--accept primary-btn",
                  attrs: {
                    disabled: !_vm.acceptTermsModel,
                    to: {
                      name: "contests/registration/alias",
                      params: { contestId: _vm.contestId }
                    }
                  }
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("Contests.TnC.Enter")) +
                      "\n          "
                  )
                ]
              )
            ],
            1
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-19aebff6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19aebff6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/contests/ContestTermsAndConditionsPage.vue
// module id = null
// module chunks = 